<div class="flex flex-col justify-center px-6 pt-6 items-center">
  <div class="flex flex-col items-center">
    <i nz-icon class="w-10 md:w-12 pb-2">
      <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
        <mask
          id="mask0_11461_273083"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="49"
          height="49"
        >
          <rect x="0.5" y="0.5" width="48" height="48" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_11461_273083)">
          <path
            d="M18.3 34.5L25.5 27.3L32.7 34.5L35.5 31.7L28.3 24.5L35.5 17.3L32.7 14.5L25.5 21.7L18.3 14.5L15.5 17.3L22.7 24.5L15.5 31.7L18.3 34.5ZM25.5 44.5C22.7333 44.5 20.1333 43.975 17.7 42.925C15.2667 41.875 13.15 40.45 11.35 38.65C9.55 36.85 8.125 34.7333 7.075 32.3C6.025 29.8667 5.5 27.2667 5.5 24.5C5.5 21.7333 6.025 19.1333 7.075 16.7C8.125 14.2667 9.55 12.15 11.35 10.35C13.15 8.55 15.2667 7.125 17.7 6.075C20.1333 5.025 22.7333 4.5 25.5 4.5C28.2667 4.5 30.8667 5.025 33.3 6.075C35.7333 7.125 37.85 8.55 39.65 10.35C41.45 12.15 42.875 14.2667 43.925 16.7C44.975 19.1333 45.5 21.7333 45.5 24.5C45.5 27.2667 44.975 29.8667 43.925 32.3C42.875 34.7333 41.45 36.85 39.65 38.65C37.85 40.45 35.7333 41.875 33.3 42.925C30.8667 43.975 28.2667 44.5 25.5 44.5Z"
            fill="#DF2525"
          />
        </g>
      </svg>
    </i>
    <h4 class="paragraph-large outfit font-bold mb-4 md:mb-6">
      {{ 'common.errorSendingReminder' | translate }}
    </h4>
  </div>
  <p class="paragraph-medium outfit font-light py-2 text-center">
    {{ 'common.errorSendingReminderMessage' | translate }}
  </p>
</div>
<div *nzModalFooter class="modal-footer">
  <div class="flex gap-4 w-full">
    <korviu-button color="ghost" (click)="onCancelClick()" class="w-full">{{
      'common.cancel' | translate
    }}</korviu-button>
    <korviu-button color="tertiary" (click)="onTryAgainButtonClick()" class="w-full">{{
      'common.tryAgain' | translate
    }}</korviu-button>
  </div>
</div>
